import request from '@/utils/request';

// -------------- 数据权限 -----------------

export function getMerchantFunction(params) {
  // 商家展示功能
  return request({
    url: '/financial/merchant/info/merchantFunction',
    method: 'get',
    params,
  });
}

// ------------------- 商家信息 -------------------

export function getBankAccount(params) {
  // 根据酒店查询银行账户信息
  return request({
    url: '/financial/merchant/info/bankAccount',
    method: 'get',
    params,
  });
}

export function getBankList(key) {
  // 银行列表
  return request({
    url: '/financial/merchant/info/bankList',
    method: 'get',
    params: { keyword: key },
  });
}

export function getBankOperateLog(params) {
  // 查看修改日志
  return request({
    url: '/financial/merchant/info/bankOperateLog',
    method: 'get',
    params,
  });
}

export function saveBankAccount(params) {
  // 保存银行账户
  return request({
    url: '/financial/merchant/info/saveBankAccount',
    method: 'post',
    data: params,
  });
}

// ------------------- 商家对账 -------------------

export function getBankLastLog(params) {
  // 最近一次审核日志
  return request({
    url: '/financial/merchant/info/bankLastLog',
    methods: 'get',
    params,
  });
}

export function getDeductionTarget(params) {
  // 抵扣总目标
  return request({
    url: '/financial/merchant/settlebill/deductionTarget',
    methods: 'get',
    params,
  });
}

export function getDeductionDetail(params) {
  // 抵扣详情
  return request({
    url: '/financial/merchant/settlebill/deductionDetailList',
    methods: 'get',
    params,
  });
}

export function exportDeduction(params) {
  // 导出抵扣
  return request({
    url: '/financial/merchant/settlebill/exportDeduction',
    methods: 'get',
    responseType: 'blob',
    params,
  });
}

export function getBills(params) {
  // 账单核对
  return request({
    url: '/financial/merchant/settlebill/member/list',
    method: 'post',
    data: params,
  });
}

export function invoiceSava(params) {
  // 发票管理
  return request({
    url: '/financial/merchant/settle/invoice/save',
    method: 'post',
    data: params,
  });
}

export function isUsedInvoice(query) {
  return request({
    url: '/financial/merchant/settle/invoice/isUsedInvoice',
    method: 'get',
    params: query,
  });
}

export function getChannelListByBillId(params) {
  // 渠道列表
  return request({
    url: '/financial/merchant/settlebill/channelListByBillNo',
    method: 'get',
    params,
  });
}

export function confirmBills(params) {
  // 账单确认核对
  return request({
    url: '/financial/merchant/settlebill/confirm',
    method: 'post',
    data: params,
    passCodes: ['80006'],
  });
}

export function confirmFXBills(params) {
  // 分销账单确认核对
  return request({
    url: '/financial/merchant/settlebill/fxConfirm',
    method: 'post',
    data: params,
  });
}

export function lookInvoices(params) {
  // 发票查看
  return request({
    url: '/financial/merchant/settle/invoice/getOne',
    method: 'get',
    params,
  });
}

export function rejectBills(params) {
  // 账单申诉
  return request({
    url: '/financial/merchant/settlebill/reject',
    method: 'post',
    data: params,
  });
}

export function rejectFXBills(params) {
  // 分销账单申诉
  return request({
    url: '/financial/merchant/settlebill/fxReject',
    method: 'post',
    data: params,
  });
}

export function getBillDetailByChannel(params) {
  // 账单总详情
  return request({
    url: '/financial/merchant/settlebill/billDetailByChannel',
    method: 'get',
    params,
  });
}

export function getDetailList(params) {
  // 根据标签查询账单详情列表
  return request({
    url: '/financial/merchant/settlebill/detailList',
    method: 'get',
    params,
  });
}

export function getBillDetails(params) {
  // 根据标签查询账单详情列表
  return request({
    url: '/financial/merchant/settlebill/detailLis',
    method: 'get',
    params,
  });
}

// ------------------- 商家打款 -------------------

export function getRemitList(params) {
  // 打款记录
  return request({
    url: '/financial/merchant/remit/list',
    method: 'get',
    params,
  });
}

// ------------------- 省份 -------------------

export function getProvinceList(params) {
  // 获取所有省
  return request({
    url: '/financial/merchant/dictionary/getProvinceList',
    method: 'get',
    params,
  });
}

export function getCityList(params) {
  // 根据省获取市列表
  return request({
    url: '/financial/merchant/dictionary/getCityList',
    method: 'get',
    params,
  });
}

export function getLogList(params) {
  // 日志查看
  return request({
    url: '/financial/merchant/log/list',
    method: 'get',
    params,
  });
}

export function getAdjustList(params) {
  // 调整金额列表
  return request({
    url: '/financial/merchant/settlebill/adjust/list',
    method: 'get',
    params,
  });
}

export function uploadCos(params) {
  // 上传
  return request({
    url: '/financial/cos/upload',
    method: 'get',
    params,
  });
}

export function getRoomRateFundManagements(params) {
  // 房费打款管理列表
  return request({
    url: '/financial/merchant/settlebill/roomRateFundManagements',
    method: 'post',
    data: params,
    notCheckRepeat: true,
  });
}

export function getMemberAwardFundManagements(params) {
  // 会员激励打款管理列表
  return request({
    url: '/financial/merchant/settlebill/memberAwardFundManagements',
    method: 'post',
    data: params,
    notCheckRepeat: true,
  });
}

export function exportMultTabByChannelAndType(params) {
  // 下载对账单
  return request({
    url: '/financial/merchant/settlebill/exportMultTabByChannelAndType',
    method: 'get',
    responseType: 'blob',
    params: params,
  });
}
// 根据userId查询结算账户信息
export function getUserSettleInfo() {
  return request({
    url: '/auth-api/v1/user/settlement/getUserSettlementAccount',
    method: 'get',
  });
}
// 保存结算账户信息
export function saveUserSettleInfo(data) {
  return request({
    url: '/auth-api/v1/user/settlement/save',
    method: 'post',
    data,
  });
}
// 修改结算账户信息
export function updateUserSettleInfo(data) {
  return request({
    url: '/auth-api/v1/user/settlement/update',
    method: 'post',
    data,
  });
}
// 查询个人银行信息
export function getPersonInfo(params) {
  return request({
    url: '/financial/merchant/info/getPersonInfo',
    method: 'get',
    params: params,
  });
}
// 个人保存银行账户
export function savePersonBankAccount(data) {
  return request({
    url: '/financial/merchant/info/savePersonBankAccount',
    method: 'post',
    data,
  });
}
// 账单核对(简约品质同一个接口)
export function getSettlebillList(params) {
  return request({
    url: '/financial/merchant/settlebill/settlebill/list',
    method: 'post',
    data: params,
  });
}
// 账单核对-费用明细简约
export function getFeedetailList(params) {
  return request({
    url: '/financial/merchant/settlebill/feedetail/list',
    method: 'get',
    params: params,
  });
}
// 账单核对-费用明细品质
export function getFeedetailListpz(params) {
  return request({
    url: '/financial/merchant/settlebill/feedetail/listpz',
    method: 'get',
    params: params,
  });
}
// 费用流水简约
export function getHotelfeeList(params) {
  return request({
    url: '/financial/merchant/settlebill/hotelfee/list',
    method: 'get',
    params: params,
  });
}
// 费用流水品质
export function getHotelfeePzlist(params) {
  return request({
    url: '/financial/merchant/settlebill/hotelfee/pzlist',
    method: 'get',
    params: params,
  });
}
// 账单核对-导出费用明细品质
export function exportpzFeedetail(params) {
  return request({
    url: '/financial/merchant/settlebill/feedetail/exportpz',
    method: 'get',
    responseType: 'blob',
    params: params,
  });
}
// 账单核对  分销房费账单核对 -费用详情
export function getCostDetail(params) {
  return request({
    url: '/financial/merchant/settlebill/dedFeeDetail',
    method: 'get',
    params: params,
  });
}
// 简约费用项枚举值
export function getFeeItems(params) {
  return request({
    url: '/financial/merchant/dictionary/feeItems',
    method: 'get',
    params: params,
  });
}
// 间夜抵扣详情
export function getJyDedFeeDetail(params) {
  return request({
    url: '/financial/merchant/settlebill/jyDedFeeDetail',
    method: 'get',
    params: params,
  });
}
// 合同期内累计欠间夜数量
export function getSumDebtJyCount(params) {
  return request({
    url: '/financial/merchant/settlebill/getSumDebtJyCount',
    method: 'get',
    params: params,
  });
}

// ------------------- 开票申请 -------------------
// 开票申请列表
export function applyList(data) {
  return request({
    url: '/financial/merchant/settle/invoice/zx/applyList',
    method: 'post',
    data,
  });
}
// 申请开票详情
export function applyDetail(params) {
  return request({
    url: '/financial/merchant/settle/invoice/zx/applyDetail',
    method: 'get',
    params,
  });
}
//酒店开票可选费用项
export function hotelInvoiceFeeItem(params) {
  return request({
    url: '/financial/merchant/settle/invoice/zx/hotelInvoiceFeeItem',
    method: 'get',
    params,
  });
}
//最近一次开票主体
export function lastInvoiceObject(params) {
  return request({
    url: '/financial/merchant/settle/invoice/zx/lastInvoiceObject',
    method: 'get',
    params,
  });
}
// 酒店开票可选费用明细
export function hotelFeeDetail(params) {
  return request({
    url: '/financial/merchant/settle/invoice/zx/hotelFeeDetail',
    method: 'get',
    params,
  });
}
// 开票申请提交
export function applySubmit(data) {
  return request({
    url: '/financial/merchant/settle/invoice/zx/applySubmit',
    method: 'post',
    data,
  });
}

// 简约月管理费抵扣详情 
export function commissionDedFeeDetail(params) {
  return request({
    url: '/financial/merchant/settlebill/commissionDedFeeDetail',
    method: 'get',
    params,
  });
}

// 酒店开票可选费用明细
export function canApply(params) {
  return request({
    url: '/financial/merchant/settle/invoice/zx/canApply',
    method: 'get',
    params,
  });
}
